import Masonry from 'masonry-layout';
import moment from 'moment/dist/moment';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery.maskedinput/src/jquery.maskedinput';
import '@fancyapps/fancybox/dist/jquery.fancybox';
import Swiper from 'swiper/bundle';
import 'imagesloaded/imagesloaded';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    /**
     * Download Quote
     */
    if ($('.download_course').length > 0) {
      $(document).on('click', '.download_course', function (e) {
        e.preventDefault();
        //	Get width and height for IE.
        let WIDTH, HEIGHT, LEFT, TOP;
        var NAME='print_preview';
        var SCROLL='yes';
        if (screen.height) {
          WIDTH  = screen.width/2;
          HEIGHT = screen.height/2;
          LEFT = (screen.width - WIDTH) / 2;
          TOP = (screen.height - HEIGHT) / 2;
        } else {
           WIDTH  = screen.availWidth/2;
           HEIGHT = screen.availHeight/2;
          LEFT = (screen.availWidth - WIDTH) / 2;
          TOP = (screen.availHeight - HEIGHT) / 2;
        }
        console.log(e, e.target)
        var program = e.currentTarget.dataset.programid;
        var catalog = e.currentTarget.dataset.catalogid;
        var URL = 'https://catalog.nec.edu/preview_degree_planner.php?catoid='+catalog+'&poid='+program+'&returnto=1049&print';
        console.log(URL);
        var popupWindow = window.open(URL,NAME,'height='+HEIGHT+',width='+WIDTH+',resizable=yes,scrollbars='+SCROLL+',menubar=no,toolbar=no,personalbar=no,statusbar=no,locationbar=no,screenX='+LEFT+',screenY='+TOP+',left='+LEFT+',top='+TOP);
        if(popupWindow != null) {
          popupWindow.focus();
        }
      })}

    /**
     * Swiper Quote
     */
    if ($('.alert_close').length > 0) {
      $(document).on('click', '.alert_close', function () {
        $('.alert_bar').remove()
        $('.with_alert').removeClass('with_alert');
      });
    }


    /**
     * Swiper Quote
     */
    if ($('.quote_slider').length > 0) {
      new Swiper('.quote_slider .swiper-container', {
        autoHeight: true, //enable auto height
        slidesPerView   : 1,
        spaceBetween    : 0,
        loop            : true,
        effect          :'fade',
        speed           : 800,
        pagination      : {
          el            : '.swiper-pagination',
          clickable     : true,
          type          : 'bullets',
        },
        navigation: {
          nextEl        : '.swiper-button-next',
          prevEl        : '.swiper-button-prev',
        },
      });
    }

    /**
     * Swiper Dynamic Content
     */
    if ($('.dynamic__slider').length > 0) {
      new Swiper('.dynamic__slider .swiper-container', {
        autoHeight: true, //enable auto height
        slidesPerView : 1,
        spaceBetween  : 0,
        loop          : true,
        effect          :'fade',
        speed           : 800,
        pagination: {
          el          : '.dynamic__slider .swiper-pagination',
          clickable   : true,
          type        : 'bullets',
        },
        navigation: {
          nextEl      : '.dynamic__slider .swiper-button-next',
          prevEl      : '.dynamic__slider .swiper-button-prev',
        },
      });
    }


    /**
     * Fancybox
     * @fancybox
     */
    $('[data-fancybox]').fancybox({
      // Options will go here
    });

    /**
     * Header
     * @type {{init: init}}
     */
    let Header = function () {

      /**
       * Install
       * @param data
       * @constructor
       */
      let Install = function () {


        /**
         * Mobile Menu
         * @click
         * Slinky Menu
         *
         */
        $(document).on('click', '#headerSlinky .menu__click', function (e) {

          const $li = $(this).parent();

          if ($li.hasClass('active_menu')) {
            $li.removeClass('active_menu');
          } else {
            $li.addClass('active_menu');
          }

          e.preventDefault();
        });

        if ($('#headerSlinky').length) {
          $('#headerSlinky > li').each(function () {
            if ($(this).find('.sub-menu').length) {
              $(this).append('<div class="menu__click"></div>');
            }
          });
        }

        /**
         * Mobile Menu
         * @click
         * Slinky Menu
         */
        $(document).on('click', '#headerSlinky > li.header__menu__item--submenu.active .menu__click', function (e) {

          $(this).parent().removeClass('active');
          $(this).parent().parent().parent().find('li.hide').removeClass('hide');
          $('.header__mob .hideSlinky').removeClass('hide');

          e.preventDefault();
        });

        /**
         * Menu Mobile Header
         * @click
         * Small Menu Accordion
         */
        $(document).on('click', '.header__mob .top-header__menu__item--submenu > a', function (e) {

          $(this).parent().toggleClass('active');
          e.preventDefault();

        });

        /**
         * Menu Mobile Header
         * @click
         */
        $(document).on('click', '#header__burger', function (e) {

          $('body')
            .toggleClass('menu__active')
            .toggleClass('no-scroll');

          e.preventDefault();
        });

      }

      /**
       * MegaMenu
       * @constructor
       */
      let Megamenu = function () {

        var visible_menu = 0,
          // speed_menu = 300,
          timer_menu;
        if ($(window).width() > 1200) {

          /**
           * header__menu__item
           * @hover
           */
          $('.header__menu__item--submenu').hover(function () {
            // var _speed_menu = $(this).hasClass('header__menu__item--submenu') && $('.megamenu .megamenu__item:visible').length ? 0 : speed_menu;

            visible_menu = 1;
            clearTimeout(timer_menu);
            // $('.megamenu__item').delay(0).slideUp(_speed_menu);
            $('.megamenu__item').removeClass('megamenu__item--active');

            const $menu = $('#megamenu-' + $(this).attr('id')),
              $this = $(this);

            $menu.addClass('megamenu__item--active');

            // $menu.stop(true).delay(_speed_menu).slideDown(_speed_menu);
            $('.header__menu').find('.active').removeClass('active');
            $this.addClass('active');
            $('.megamenu').addClass('megamenu--active');

          }, function () {

            timer_menu = setTimeout(function () {
              if (visible_menu === 1) {
                visible_menu = 0;
                // $('.megamenu__item').stop(true).delay(speed_menu).slideUp(speed_menu);
                $('.megamenu__item').removeClass('megamenu__item--active');
                $('.header__menu').find('.active').removeClass('active');
                $('.megamenu').removeClass('megamenu--active');
              }

            }, 0);

          });

          /**
           * megamenu__item
           * @hover
           */
          $('.megamenu__item').hover(function () {

            visible_menu = 1;
            clearTimeout(timer_menu);

          }, function () {

            // var $this = $(this);
            clearTimeout(timer_menu);

            if (visible_menu === 1) {
              // $this.stop(true).delay(speed_menu).slideUp(speed_menu);
              $('.header__menu').find('.active').removeClass('active');
              $('.megamenu').removeClass('megamenu--active');
              $('.megamenu__item').removeClass('megamenu__item--active');
              visible_menu = 0;
            }

          });

        }
      }

      /**
       * @return
       */
      return {
        init: function () {
          Install();
          Megamenu();
        },
      };
    }();

    /**
     * Init Header
     */
    Header.init();

    /**
     * TourHeader
     * @type {{init: init}}
     */
    let TourPage = function () {

      /**
       * Header
       * @param data
       * @constructor
       */
      let Header = function () {

        /**
         * Scroll Page
         * @scroll
         */
        $(window).on('scroll', function () {

          const windowPosition = $(window).scrollTop();

          if( windowPosition > 0 ) {
            $('.header_tour').addClass('scroll')
          }else{
            $('.header_tour').removeClass('scroll')
          }


        }).scroll();

      }

      /**
       * Show Wrapper
       * @constructor
       */
      let ShowWrapper = function () {

        $('.tour').css('opacity', 1);

        setTimeout(function () {

          $('.tour__preloader').stop().animate({
            opacity: 0,
          }, 400, function () {

            $('.tour__preloader').remove();
            $('body').addClass('isLoaded');

          });

        }, 100);

      }

      /**
       * Install
       * @param data
       * @constructor
       */
      let Install = function () {

        $('.tour').imagesLoaded()
          // eslint-disable-next-line no-unused-vars
          .always( function( instance ) {
            console.log('all images loaded');
          })
          // eslint-disable-next-line no-unused-vars
          .done( function( instance ) {

            ShowWrapper();

          })
          .fail( function() {
            console.log('all images loaded, at least one is broken');

            ShowWrapper();

          })
          // eslint-disable-next-line no-unused-vars
          .progress( function( instance, image ) {
            //var result = image.isLoaded ? 'loaded' : 'broken';
          });

      }

      /**
       * Megamenu
       * @constructor
       */
      let Megamenu = function () {

        /**
         * Swiper Megamenu
         */
        if ( $('.header_tour__megamenu__slider').length > 0 ) {

          let swiperMegamenu = {};
          $('.header_tour__megamenu__slider').each(function (index) {
            let $this = $(this);
            $this.addClass('swiperMegamenu-' + index);

            swiperMegamenu[index] =  new Swiper('.swiperMegamenu-' + index + ' .swiper-container', {
              slidesPerView         : 'auto',
              spaceBetween          : 8,
              loop                  : false,
              speed                 : 500,
              observer              : true,
              observeParents        : true,
              observeSlideChildren  : true,
              slidesOffsetBefore    : 44,
              pagination: {
                el          : '.swiperMegamenu-' + index + ' .swiper-pagination',
                clickable   : true,
                type        : 'bullets',
              },
              navigation: {
                nextEl      : '.swiperMegamenu-' + index + ' .swiper-button-next',
                prevEl      : '.swiperMegamenu-' + index + ' .swiper-button-prev',
              },
              breakpoints: {
                1023: {
                  spaceBetween          : 12,
                  slidesOffsetBefore    : 0,
                },
              },
            });

          });





        }
      }

      /**
       * Cards
       * @constructor
       */
      let Cards = function () {


      }


      /**
       * @return
       */
      return {
        init: function () {
          Install();
          Header();
          Megamenu();
          Cards();
        },
      };
    }();

    /**
     * Init Tour Page
     */
    if( $('.tour').length ) {
      TourPage.init();
    }

    /**
     * breadcrumbs
     * @length
     * @each
     */
    if ($('.breadcrumbs').length) {

      $('.breadcrumbs li').each(function () {

        if ($(this).find('ul').length) {

          $(this).addClass('breadcrumbs__dropdown');

        }

      });

      /**
       * Hide Breadcrumbs DropDown
       * @mouseup
       */
      $(document).mouseup(function (e) {

        const container = $('.breadcrumbs__dropdown');

        if (container.has(e.target).length === 0) {

          container.removeClass('active');

        }

      });

    }

    /**
     * Breadcrumbs
     * @click
     */
    $(document).on('click', '.breadcrumbs__dropdown > a', function (e) {

      $(this).parent().toggleClass('active');

      e.preventDefault();

    });

    /**
     * News & Events
     * @Masonry
     */
    if ($('.newseventsMasonry').length) {

      $('.newseventsMasonry').each(function (index) {

        var $elem = 'masonry-newsevents-' + index;

        $(this).addClass($elem);

        var $masonry = '.' + $elem;

        var $grid = {};

        $grid[index] = new Masonry($masonry, {
          percentPosition: true,
          itemSelector: '.newseventsMasonry-item',
          gutter: 0,
          transitionDuration: 0,
          columnWidth: '.grid-sizer',
        });

        $(window).on('load resize', function () {
          $grid[index].reloadItems();
          $grid[index].layout();
        });

      });

    }

    /**
     * Open Nav Mobile Left Sidebar
     */
    $(document).on('click', '.openNavSection', function (e) {

      $(this).toggleClass('active');
      $(this).parent().find('ul').toggleClass('open');
      e.preventDefault();

    });

    /**
     * header Search
     */
    $('.top-header__search').on('click', function (e) {
      e.preventDefault();
      $(this).addClass('top-header__search--active');
    });

    /**
     * header Search
     */
    $(document).on('click', '.top-header__search__icon', function (e) {

      $(this).closest('form').trigger('submit');
      e.preventDefault();

    });

    /**
     * page Search
     */
    $(document).on('click', '.dropSearchOrder', function (e) {

      $('.dropSearchDropdown').toggleClass('active');
      e.preventDefault();

    });

    $(document).mouseup(function (e) {
      var div = $('.dropSearchDropdown');
      if (!div.is(e.target)
        && div.has(e.target).length === 0) {
        div.removeClass('active');
      }
    });

    /**
     * Replace all SVG images with inline SVG
     */
    jQuery('img.svg').each(function () {
      const $img = jQuery(this);
      const imgID = $img.attr('id');
      const imgClass = $img.attr('class');
      const imgURL = $img.attr('src');

      jQuery.get(imgURL, function (data) {
        // Get the SVG tag, ignore the rest
        let $svg = jQuery(data).find('svg');

        // Add replaced image ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
        if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        // Replace image with new SVG
        $img.replaceWith($svg);

      }, 'xml');

    });


    $(document).on('click', '.closeFloatingSection', function () {
      $('.floating_section').remove();
    });

    let userScrolled = false;
    const refreshspeed = 1000 / 10;

    $(window).on('scroll', function () {

      const windowPosition = $(window).scrollTop(),
        topPanel = $('.top-header__inner').outerHeight();

      if (windowPosition > topPanel) {
        $('header.header').addClass('stiky');
        $('.main').addClass('active');
      } else {
        $('header.header').removeClass('stiky');
        $('.main').removeClass('active');
      }

      userScrolled = true;

    }).scroll();

    function isOnScreen(x) {
      if (x.length) {
        var top_of_element = x.offset().top;
        var bottom_of_screen = $(window).scrollTop() + window.innerHeight - 300;
        return bottom_of_screen > top_of_element;
      }
    }

    executeOnScroll();

    function executeOnScroll() {
      $('.fadein, .animated').each(function () {
        if (isOnScreen($(this))) {
          $(this).addClass('onscreen');
        }
      });
    }

    function checkIfScrolled() {
      if (userScrolled) {
        window.requestAnimationFrame(executeOnScroll);
        userScrolled = false;
      }
    }

    setInterval(checkIfScrolled, refreshspeed);

    $(document).on('click', '.to_top__link', function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: 0}, 1000);
    });

    if(window.location.hash) {
      //Url from a different page:
      var hashID = window.location.hash.replace('#', '');
  
      console.log(hashID);
  
      $('#' + (hashID)).addClass('active');   
    }

    $('.dynamic__navsections-list a[href^="#"]').on('click', function(){
      var anchor = $(this).attr('href').replace('#', '');
      
      console.log(anchor);

      $('.dynamic__accordion-list').find('#' + anchor).addClass('active');
    });

    /**
     * ArchivePost
     * @type {{init: init}}
     */
    let ArchivePost = function () {

      const loader = {message: '', overlayCSS: {background: '#fff', opacity: 0.6}};

      /**
       * Install
       * @param data
       * @constructor
       */
      let Install = function () {

        /**
         *
         * @type {*|string}
         */
        var url_string = window.location.href,
          url = new URL(url_string),
          category = url.searchParams.get('category');

        if (category > 0) {

          $('.ArchivePostCatLinkAll').prop('checked', false);
          $('[name="program[' + category + ']"]').prop('checked', true);
          $('.ArchivePostCat').val(category + ',');
          Ajax();

        }

        /**
         * Datepicker
         */

        let $datepicker = $('.archive_section .date_picker_value'),
          $button = $('.archive_section .date_picker_button'),
          $paged = $('.ArchivePostForm [name="paged"]');

        $datepicker.datepicker({
          dateFormat: 'dd M yy',
          beforeShow: function () {

            $('.date_picker').append($('#ui-datepicker-div')).ready(function () {
                $('#ui-datepicker-div').prepend(
                  $('<input type="text" value="" placeholder="mm/dd/yyyy" class="ui-input">')
                    .mask(
                      '99/99/9999',
                      {
                        completed: function () {

                          $datepicker.datepicker('hide');

                          var theDate = new Date(this.val()),
                            dateFormatted = $.datepicker.formatDate('yy-mm-dd', theDate);

                          $datepicker.val(dateFormatted);
                          $button.text(moment(dateFormatted).format('MMM YYYY'));

                          $datepicker.datepicker('setDate', new Date(dateFormatted));

                          $('[name="type_date"]').val('date');
                          $('[name="date"]').val(dateFormatted);

                          $paged.val(1);

                          Ajax();
                        },
                      }
                    )
                );
              }
            );

          },
          onSelect: function (date) {
            $button.text(date);

            var theDate = new Date(Date.parse($(this).datepicker('getDate'))),
              dateFormatted = $.datepicker.formatDate('yy-mm-dd', theDate);

            $datepicker.val(dateFormatted);

            $datepicker.datepicker('setDate', new Date(dateFormatted));

            $('[name="type_date"]').val('date');
            $('[name="date"]').val(dateFormatted);

            Ajax();

          },
          onChangeMonthYear: function () {
            $('.date_picker').append($('#ui-datepicker-div')).ready(function () {
              $('#ui-datepicker-div').prepend($('<input type="text" value="" placeholder="mm/dd/yyyy" class="ui-input">').mask('99/99/9999'));
            });
          },
        });

        /**
         * Open Datepicker
         */
        $(document).on('click', '.archive_section .date_picker_button', function () {
          $datepicker.show().focus().hide();
        });

        /**
         * Next and Prev Month
         * @click
         */
        $(document).on('click', '.archive_section .filterNewsEventMonth', function () {

          var $this = $(this),
            $inp = $datepicker,
            //data = $inp.val(),
            data = $inp.datepicker( 'getDate' ),
            now = new Date(data),
            future = null;

          if ($this.hasClass('filterNewsEventMonthNext')) {
            future = now.setMonth(new Date(now.getTime() + 36000 * 600).getMonth() + 1, 1);
          }

          if ($this.hasClass('filterNewsEventMonthPrev')) {
            future = now.setMonth(new Date(now.getTime() + 36000 * 600).getMonth() - 1, 1);
          }



          $button.text(moment(future).format('MMM YYYY'));
          //$inp.val(moment(future).format('YYYY-MM-DD'));
          $inp.datepicker('setDate', new Date(future) );

          $('[name="type_date"]').val('month');
          $('[name="date"]').val(moment(future).format('YYYY-MM-DD'));

          $(this).block(loader);

          $paged.val(1);

          Ajax();

        });

        /**
         * ArchivePostCatLink
         * @change
         *
         */
        $(document).on('change', '.ArchivePostCatLinkItem', function () {

          var $inp = $('.ArchivePostCat'),
            def_value = $inp.val(),
            $this = $(this);

          if ($this.is(':checked')) {

            $inp.val(def_value + $this.val() + ',');

          } else {

            $inp.val(function (index, value) {
              return value.replace($this.val() + ',', '');
            });

          }

          //$('[name="type_date"]').val('');

          if ($inp.val().length == 0) {
            $('.ArchivePostCatLinkAll').prop('checked', true);
          } else {
            $('.ArchivePostCatLinkAll').prop('checked', false);
          }

          $paged.val(1);
          Ajax();

        });

        /**
         * All Category
         */
        $(document).on('change', '.ArchivePostCatLinkAll', function () {
          $(this).prop('checked', true);
          $('.ArchivePostCat').val('');
          $('.ArchivePostCatLinkItem').prop('checked', false);

          $paged.val(1);
          Ajax();
        });

        /**
         * Pagination
         */
        $(document).on('click', '.ArchivePostPagination a', function (e) {

          var arr = $(this).attr('href').split('/');

          arr = arr.filter(function (e) {
            return e
          });

          var number = arr.pop();

          $paged.val(number);

          Ajax();

          e.preventDefault()
        });

      }

      /**
       * Ajax
       * @param data
       * @constructor
       */
      let Ajax = function (data = '') {

        /**
         *
         * @type {jQuery|HTMLElement}
         */
        const $form = $('.ArchivePostForm'),
          $container_result = $('.resultAjax');
        /**
         * Data
         * @type {string}
         */
        data += $form.serialize() + '&month=';

        $.ajax({
          beforeSend: function () {
            $container_result.block(loader);
          },
          data: data,
          dataType: 'json',
          method: 'POST',
          complete: function () {
            $container_result.unblock();
            $('.filterNewsEventMonthPrev').unblock();
            $('.filterNewsEventMonthNext').unblock();
          },
          success: function (response) {


            /**
             * Html
             */
            $container_result.html(response.data.html).ready(function () {

              if( $('.newseventsMasonry').length ) {

                let grid = new Masonry('.newseventsMasonry');
                grid.reloadItems();
                setTimeout(function () {
                  grid = new Masonry('.newseventsMasonry', {
                    percentPosition: true,
                    itemSelector: '.newseventsMasonry-item',
                    isInitLayout: true,
                    gutter: 0,
                    transitionDuration: 0,
                    columnWidth: '.grid-sizer',
                  });
                }, 200)

              }
            });

            /**
             * Masonry
             */
            $(window).trigger('resize');

            /**
             * Month Panel
             */
            // $month_panel.html(response.data.month);

          },
          url: window.nec.ajax_url,
        });

      }

      /**
       * @return
       */
      return {
        init: function () {
          Install();

        },
      };
    }();

    /**
     * Init Header
     */
    ArchivePost.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js